/**
 * Utilitário para validação de perfil do usuário
 * Considera se o CPF é obrigatório baseado na configuração do ambiente
 */

/**
 * Verifica se o CPF é obrigatório no ambiente atual
 * Por padrão, CPF é opcional em staging/local e obrigatório em produção
 */
export const isDocumentRequired = (): boolean => {
  // Pode ser configurado via variável de ambiente VITE_REQUIRE_DOCUMENT
  // Se não configurado, assume false (opcional) para staging/local
  const requireDocument = import.meta.env.VITE_REQUIRE_DOCUMENT;
  if (requireDocument === 'true' || requireDocument === true) {
    return true;
  }
  // Por padrão, CPF é opcional em staging/local
  return false;
};

/**
 * Verifica se o perfil do usuário está completo
 * @param user - Dados do usuário
 * @returns true se o perfil está completo
 */
export const isProfileComplete = (user: {
  firstName?: string | null;
  lastName?: string | null;
  documentNumber?: string | null;
  phone?: string | null;
}): boolean => {
  const hasFirstName = !!(user.firstName && user.firstName.trim());
  const hasLastName = !!(user.lastName && user.lastName.trim());
  const hasPhone = !!(user.phone && user.phone.trim());
  const hasDocument = !!(user.documentNumber && user.documentNumber.trim());

  // Nome, sobrenome e telefone são sempre obrigatórios
  if (!hasFirstName || !hasLastName || !hasPhone) {
    return false;
  }

  // CPF só é obrigatório se configurado
  if (isDocumentRequired() && !hasDocument) {
    return false;
  }

  return true;
};
